import { Languages, Views } from '../../enums'

const browserLanguage = (): string =>
  (
    navigator &&
    (navigator.language ||
      navigator['browserLanguage'] ||
      navigator['userLanguage'] ||
      (navigator.languages && navigator.languages[0]) ||
      'en')
  )
    .toLowerCase()
    .slice(0, 2)

export const getViewLanguage = () => {
  return Languages[browserLanguage()] || Languages.en
}

/** Dynamically imports the appropriate code-split/chunked copy for view */
export const getViewLocale = async ({ language, view }: { language: Languages, view: Views }): Promise<{ copy: object }> => {
  const copy = await import(/* webpackChunkName: "gdprModalLocale" */ `./copy/${Views[view]}/${language}`)
  return copy.default
}
